import { render, staticRenderFns } from "./message-preview.vue?vue&type=template&id=6b997991"
import script from "./message-preview.vue?vue&type=script&lang=js"
export * from "./message-preview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports